import { BadgeCheck } from "lucide-react";

/**
 * VerifiedBadge — small gold check displayed next to verified members.
 * `size` controls icon size; `withLabel` shows the word VERIFIED.
 */
export default function VerifiedBadge({ size = 14, withLabel = false, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-gold ${className}`}
      title="Verified member"
      data-testid="verified-badge"
    >
      <BadgeCheck size={size} strokeWidth={2} fill="rgba(212,175,55,0.18)" />
      {withLabel && (
        <span className="text-[10px] tracking-overline text-gold-soft uppercase">Verified</span>
      )}
    </span>
  );
}
